import React, { Fragment, useContext } from "react";
import aws from "../../../config/aws";
import { Card } from "antd";
import { Link } from "react-router-dom";
import "../Productos/Cards_Normales/card_producto.scss";
import { MenuContext } from "../../../context/carritoContext";
import { makeStyles } from "@material-ui/styles";
import {
  agregarPorcentaje,
  formatoMexico,
} from "../../../config/reuserFunction";

const gridStyle = { width: "100%", padding: 0, marginBottom: "1.5rem" };

export default function CardOferta(props) {
  const { producto, precioPromocion } = props;
  const { colores } = useContext(MenuContext);

  const useStyles = makeStyles({
    background: {
      backgroundColor: colores.bodyPage.card.background,
      border: "none",
      "& .text-color": {
        color: colores.bodyPage.card.text,
      },
    },
  });
  const classes = useStyles();

  return (
    <Fragment>
      <Link to={`/vista_producto/${producto._id}`}>
        <Card.Grid
          hoverable
          style={gridStyle}
          className={"contenedor-card-producto-principal " + classes.background}
        >
          <Card
            className={"contenedor-card-body " + classes.background}
            cover={
              <div className="contenedor-imagen-oferta">
                <div className="oferta-frente">
                  <h5 className="shadow">OFERTA</h5>
                  <p>-{agregarPorcentaje(precioPromocion, producto.precio)}%</p>
                </div>

                <div className="contenedor-imagen-principal">
                  <img
                    className="imagen-principal"
                    alt="producto"
                    src={aws + producto.imagen}
                  />
                </div>
              </div>
            }
          >
            <div className="container">
              <div>
                <h4 className=" titulo-elipsis">{producto.nombre}</h4>
              </div>
              {producto.precio ? (
                <div>
                  <div className="cont-precios-frente ">
                    <div>
                      <h2 className="font-peque precio-producto mr-2 mb-0">
                        ${formatoMexico(producto.precio)}
                      </h2>
                      <h3 className="font-prin precio-rebaja d-inline mr-1">
                        ${formatoMexico(precioPromocion)}
                      </h3>
                    </div>
                    <p className="font-peque porcentaje-descuento d-inline">
                      -{agregarPorcentaje(precioPromocion, producto.precio)}%
                    </p>
                  </div>
                </div>
              ) : null}
            </div>
          </Card>
        </Card.Grid>
      </Link>
    </Fragment>
  );
}
